// extracted by mini-css-extract-plugin
export default {"alarmLogs":"AuditTrail_alarmLogs__0+L-J","wrapper":"AuditTrail_wrapper__y3aVB","bodywrapper":"AuditTrail_bodywrapper__zqOxT"};